export default __webpack_public_path__ + "static/media/cross-white.01bcf5b6.svg";